import { Injectable } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from '../services/config.service';

@Injectable({
	providedIn: 'root'
})
export class MessagesService {

	broadcastEvent: EventEmitter<string> = new EventEmitter();

	constructor(private configService: ConfigService, private http: HttpClient) { }

	getUserMessages(page: number, size: number) {
		let config = this.configService.getConfig();
		return firstValueFrom(this.http.get(config.notifications.usermessages + "?page=" + page + "&size=" + size + "&sort=created,DESC"));
	}
	
	getUserUnreadMessages(page: number, size: number) {
		let config = this.configService.getConfig();
		return firstValueFrom(this.http.get(config.notifications.usermessages + "/unread?page=" + page + "&size=" + size));
	}
	
	getUserMessagesCount() {
		let config = this.configService.getConfig();
		return firstValueFrom(this.http.get(config.notifications.usermessages + "/count"));
	}
	
	getUserMessagesUnreadCount(): Promise<number> {
		let config = this.configService.getConfig();
		return firstValueFrom(this.http.get<number>(config.notifications.usermessages + "/unreadcount")).then(res => res ?? 0);
	}
	
	deleteAllUserMessages() {
		let config = this.configService.getConfig();
		return firstValueFrom(this.http.delete(config.notifications.usermessages + "/delete/all"));
	}
	
	deleteUserMessage(ids: number[]) {
		let config = this.configService.getConfig();
		return firstValueFrom(this.http.delete(config.notifications.usermessages + "/delete?ids=" + ids.join(',')));
	}
	
	readUserMessage(id: number) {
		let config = this.configService.getConfig();
		return firstValueFrom(this.http.post(config.notifications.usermessages + "/read?ids=" + id, {}));
	}
	
	readAllUserMessages() {
		let config = this.configService.getConfig();
		return firstValueFrom(this.http.post(config.notifications.usermessages + "/read/all", {}));
	}

	triggerMessagesReload(): void {
		this.broadcastEvent.emit('reloadMessages');
	}

	triggerMessagesReloaded(): void {
		this.broadcastEvent.emit('messagesReloaded');
	}
}
